'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modal = require('./modal');

var instance = {
    create: function () {
        if (!instance.modal) {
            instance.modal = new modal.Modal({
                el: document.createElement('div'),
                propsData: { onHide: instance.hide }
            });
            document.body.appendChild(instance.modal.$el);
        }
    },
    show: function (config) {
        instance.create();
        instance.modal.config = config;
        instance.modal.show = true;
    },
    hide: function () {
        instance.modal && (instance.modal.show = false);
    }
};

exports.Modal = modal.Modal;
exports.default = instance;
